module.exports = __webpack_public_path__ + "badge.svg?cc811abb4d273ec68e53519760beea88";